import React from "react";
import { i18n } from "../../translate/i18n";

export const CHANNEL_UNKNOWN = "Não foi informado de onde ele veio";

const PRESET_VALUES = {
	instagram: "Instagram",
	facebook: "Facebook",
	google: "Google",
	whatsapp: "WhatsApp",
	indicacao: "Indicação",
	site: "Site",
	unknown: CHANNEL_UNKNOWN,
};

export function channelKeyFromValue(value) {
	const raw = String(value || "").trim();
	if (!raw || raw === CHANNEL_UNKNOWN) return "unknown";
	const found = Object.entries(PRESET_VALUES).find(
		([, label]) => label.toLowerCase() === raw.toLowerCase()
	);
	if (found) return found[0];
	return "other";
}

export function resolveChannelPayload(channelKey, channelOther, referredBy) {
	const key = String(channelKey || "unknown");
	let acquisitionChannel = PRESET_VALUES[key] || CHANNEL_UNKNOWN;
	if (key === "other") {
		const custom = String(channelOther || "").trim();
		acquisitionChannel = custom || CHANNEL_UNKNOWN;
	}
	let who = String(referredBy || "").trim();
	if (key !== "indicacao" && channelKeyFromValue(acquisitionChannel) !== "indicacao") {
		who = "";
	}
	return { acquisitionChannel, referredBy: who };
}

export function formatChannelLabel(channel, referredBy) {
	const origin = String(channel || "").trim() || CHANNEL_UNKNOWN;
	const who = String(referredBy || "").trim();
	if (who) return `${origin} · ${who}`;
	return origin;
}

export default function BookingChannelFields({
	channelKey,
	channelOther,
	referredBy,
	onChange,
	selectClassName = "form-select mt-1 w-full min-w-0 max-w-full",
	inputClassName = "form-input mt-1 w-full min-w-0 max-w-full",
	labelClassName = "block w-full min-w-0 max-w-full text-xs text-default-600 dark:text-default-300",
}) {
	const showOther = channelKey === "other";
	const showReferred = channelKey === "indicacao";

	return (
		<div className="w-full min-w-0 max-w-full space-y-2 overflow-hidden">
			<label className={labelClassName}>
				{i18n.t("contactDrawer.bookings.channelLabel")}
				<select
					className={selectClassName}
					value={channelKey || "unknown"}
					onChange={(e) => onChange({ channelKey: e.target.value })}
				>
					<option value="unknown">
						{i18n.t("contactDrawer.bookings.channelUnknown")}
					</option>
					<option value="instagram">Instagram</option>
					<option value="facebook">Facebook</option>
					<option value="google">Google</option>
					<option value="whatsapp">WhatsApp</option>
					<option value="indicacao">
						{i18n.t("contactDrawer.bookings.channelReferral")}
					</option>
					<option value="site">{i18n.t("contactDrawer.bookings.channelSite")}</option>
					<option value="other">{i18n.t("contactDrawer.bookings.channelOther")}</option>
				</select>
			</label>
			{showOther ? (
				<label className={labelClassName}>
					{i18n.t("contactDrawer.bookings.channelOtherLabel")}
					<input
						className={inputClassName}
						value={channelOther || ""}
						onChange={(e) => onChange({ channelOther: e.target.value })}
						placeholder={i18n.t("contactDrawer.bookings.channelOtherPlaceholder")}
					/>
				</label>
			) : null}
			{showReferred ? (
				<label className={labelClassName}>
					{i18n.t("contactDrawer.bookings.referredByLabel")}
					<input
						className={inputClassName}
						value={referredBy || ""}
						onChange={(e) => onChange({ referredBy: e.target.value })}
						placeholder={i18n.t("contactDrawer.bookings.referredByPlaceholder")}
					/>
				</label>
			) : null}
		</div>
	);
}
